import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../../packages/Filters/shared/types/jsonQuery';

export function trackOfferCardShow({
  position,
  offerId,
  jsonQuery,
}: {
  position: number;
  offerId: number;
  jsonQuery: IJsonQuery;
}) {
  ca('teaser', {
    sc: jsonQuery,
    product: {
      id: offerId,
      name: 'Listing_show_card_snippet',
      extra: {
        offerType: 'offer',
      },
      position,
    },
  });
}
